import React from 'react'

const ChatSkeleton = () => {
    return (
        <div className="chat-item skeleton-card">
            <div className="d-flex align-items-center gap-3">
                <div className="skeleton-icon">
                    <div className="placeholder-glow">
                        <span className="placeholder" style={{ width: '18px', height: '18px', borderRadius: '4px' }}></span>
                    </div>
                </div>
                <div className="skeleton-content flex-grow-1">
                    <div className="placeholder-glow mb-2">
                        <span className="placeholder col-8" style={{ height: '14px' }}></span>
                    </div>
                    <div className="placeholder-glow">
                        <span className="placeholder col-4" style={{ height: '11px' }}></span>
                    </div>
                </div>
                <div className="skeleton-delete">
                    <div className="placeholder-glow">
                        <span className="placeholder" style={{ width: '16px', height: '16px', borderRadius: '4px' }}></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatSkeleton
